"use client";

import { AlertsSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedAlertsSection from "../Components/GeneratedAlertsSection";

const Alerts: FC<AlertsSectionProps> = (props) => {
  return <GeneratedAlertsSection {...props} />;
};

export default Alerts;
